import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { noteColorCss } from './lib/colors';
import './index.css';

// Variables CSS des couleurs de notes (clair/sombre), générées depuis la palette partagée.
const style = document.createElement('style');
style.textContent = noteColorCss();
document.head.appendChild(style);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
